import { queryAvailability } from './api/query-availability';
import { getLocalDateTimeEndOfDay, getLocalDateTimeStartOfDay } from './date-utils';
export const getAvailabilityDates = _ref => {
  let {
    httpClient: _httpClient,
    errorHandler
  } = _ref;
  return async _ref2 => {
    var _await$queryAvailabil;
    let {
      serviceId,
      fromDate,
      toDate,
      timeZone
    } = _ref2;
    const fromLocalDate = getLocalDateTimeStartOfDay(fromDate);
    const toLocalDate = getLocalDateTimeEndOfDay(toDate);
    return ((_await$queryAvailabil = await queryAvailability({
      httpClient: _httpClient,
      errorHandler,
      request: {
        query: {
          filter: {
            serviceId: [serviceId],
            startDate: fromLocalDate,
            endDate: toLocalDate,
            bookable: true
          }
        },
        timezone: timeZone,
        slotsPerDay: 1,
        allowProxyToAvailability: true
      }
    })) == null ? void 0 : _await$queryAvailabil.availabilityEntries) || [];
  };
};
//# sourceMappingURL=get-availability-dates.js.map